import isPropValid from '@emotion/is-prop-valid';
import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import { cssStyles } from '../..';

import type { BoxProps } from '@mui/material';
import type { FC } from 'react';

interface BackgroundImageGradientProps extends BoxProps {
  url: string;
  filter: string;
}

// export const BackgroundImageGradient = styled<BackgroundImageGradientProps>(
//   Box,
//   {
//     shouldForwardProp: (prop) => isPropValid( prop ) && prop !== 'url' && prop !== 'display',
//   },
// )(({ theme, url, display }) => ({
//   // display: 'none',
//   display: { xs: 'none', lg: 'block' },
//   width: '50%',
//   height: '100%',
//   position: 'absolute',
//   top: 0,
//   padding: theme.spacing( 10, 0 ),
//   filter: 'brightness(1.25)',
//   ...cssStyles( theme ).bgImage( {
//     direction: 'right',
//     url,
//     startColor: `${alpha( theme.palette.grey[300], 0 )} 0%`,
//     endColor: `${alpha( theme.palette.grey[300], 0.6 )} 50%`,
//   } ),
//   [theme.breakpoints.down( 'sm' )]: {
//     ...cssStyles( theme ).bgImage( {
//       direction: 'bottom',
//       url,
//       startColor: `${alpha( theme.palette.grey[300], 0 )} 0%`,
//       endColor: `${alpha( theme.palette.grey[300], 0.6 )} 25%`,
//     } ),
//     [theme.breakpoints.up( 'md' )]: {
//       padding: theme.spacing( 15, 0 ),
//     },
//   },
// }));

export const BackgroundImageGradient: FC<BackgroundImageGradientProps> = (
  { children, url, filter = 'brightness(1.25)', ...props },
) => (
  <Box
    // width="50%"
    height="100%"
    // position="absolute"
    // top={0}
    padding={(theme) => theme.spacing( 10, 0 )}
    {...props}
    sx={(theme) => ({
      filter,
      ...cssStyles( theme ).bgImage( {
        direction: 'right',
        url,
        startColor: `${alpha( theme.palette.grey[300], 0 )} 0%`,
        endColor: `${alpha( theme.palette.grey[300], 0.6 )} 50%`,
      } ),
      [theme.breakpoints.down( 'sm' )]: {
        ...cssStyles( theme ).bgImage( {
          direction: 'bottom',
          url,
          startColor: `${alpha( theme.palette.grey[300], 0 )} 0%`,
          endColor: `${alpha( theme.palette.grey[300], 0.6 )} 25%`,
        } ),
        [theme.breakpoints.up( 'md' )]: {
          padding: theme.spacing( 15, 0 ),
        },
      },
    })}
  >
    {children}
  </Box>
);
